import {
    REVIEW_IMAGE_UPLOAD_ERROR,
    REVIEW_IMAGE_UPLOAD_START,
    REVIEW_IMAGE_UPLOAD_SUCCESS
} from '../constants';
import { setLoaderComplete, setLoaderStart } from './loader/loader';
import { uploadReviewImageMutation as mutation, getOrder as query } from '../lib/graphql';

export function uploadReviewImage(id, picture) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch(setLoaderStart('reviewImageLoader'))
            dispatch({
                type: REVIEW_IMAGE_UPLOAD_START
            })
            const { data } = await client.mutate({
                mutation,
                variables: {
                    orderId: id,
                    picture
                },
                refetchQueries: [{ query }]
            })
            dispatch(setLoaderComplete('reviewImageLoader'))
            if (data?.uploadReviewImageMutation?.status === 200) {
                dispatch({
                    type: REVIEW_IMAGE_UPLOAD_SUCCESS
                });
            } else {
                dispatch({
                    type: REVIEW_IMAGE_UPLOAD_ERROR
                })
            }
        } catch (err) {
            dispatch({
                type: REVIEW_IMAGE_UPLOAD_ERROR
            })
        }
    }
}